import React from 'react';

// Media block — a single image with REQUIRED alt (accessibility) + optional caption. Presentation
// only. Asset-backed: usable once real images exist. Lazy-loaded; semantic <figure>.
export default function Media({ src, alt, caption }) {
  return (
    <figure className="mb-10">
      <img src={src} alt={alt} loading="lazy" className="w-full rounded-2xl border border-neutral-200" />
      {caption ? <figcaption className="mt-2 text-sm text-neutral-500">{caption}</figcaption> : null}
    </figure>
  );
}
